<script setup>
/**
 * TMainForm — базовая SCADA-форма.
 */
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import DesignFacility from '../DesignFacility.vue';
import PropertyTable from './PropertyTable.vue';
import ControlButtons from './ControlButtons.vue';
import ScriptLogs from './ScriptLogs.vue';

import { useScadaForm } from './composables/useScadaForm';
import { usePropertyUtils } from './composables/usePropertyUtils';
import { useComponentUtils } from './composables/useComponentUtils';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: Boolean, default: null },
  buttons: { type: Array, default: () => [] },
  defaultDesign: { type: String, default: null },
  defaultChangeScript: { type: String, default: null },
  defaultProccessScript: { type: String, default: null },
});

const emit = defineEmits(['setScript']);

// --- Composables ---
const {
  getStylePropertyTable,
  getStyleLogs,
  propertyColumnVisible,
  facilityChanged,
  setupFormLifecycle,
} = useScadaForm(/*{
  onFacilityChanged: (f) => {
    console.log(f, 'onFacilityChanged test setupFormLifecycle');
  },
}*/);

const {
  propertyByNameFlangeNo,
  propertyByURIFlangeNo,
  propertyByName,
  propertyBind,
  write,
  getPropertyDB,
  writeLoadedValue,
  propertyWrite,
  sendVariableForComponent,
  valueWriteFromComponent,
  onGetVariable,
  execProc,
} = usePropertyUtils();

const {
  componentByTypeId,
  componentById,
  componentByName,
  componentByTag,
  createTable,
  getChild,
  prepareURI,
  prepareURIData,
  getBit,
  styleEventGroup,
  toColor,
  invertColor,
  propertyByEvent,
  varName,
  globalVariables,
  global,
} = useComponentUtils();

// --- Lifecycle ---
const lifecycle = setupFormLifecycle();

const controlButtonsRef = ref(null);

const controlsValue = computed(() => controlButtonsRef.value?.controlsValue ?? {});

defineExpose({
  //TODO: сюда передаем методы которые нужны для кнопок на панели мнемосхемы
  write,
  propertyByName,
  propertyWrite,
  writeLoadedValue,
  getPropertyDB,
  controlsValue,
});

onMounted(() => {
  lifecycle.onMountedHandler();
  if (props.defaultDesign || props.defaultChangeScript || props.defaultProccessScript) {
    emit('setScript', {
      design: props.defaultDesign,
      facility_changed_script: props.defaultChangeScript,
      facility_process_script: props.defaultProccessScript,
    });
  }
});

onBeforeUnmount(() => {
  lifecycle.onBeforeUnmountHandler();
});
</script>

<template>
  <!--<div class="scada-form-wrapper">  TODO: если раскоментировать то не нужно отсутпы для мнемосхемы y72 x175(которая высчитывается)-->
  <ControlButtons ref="controlButtonsRef" :controls="buttons" :script-id="scriptId" />

  <DesignFacility :script-id="scriptId" :interception="interception" :default-script="{
    design: defaultDesign,
    changeScript: defaultChangeScript,
    proccessScript: defaultProccessScript,
  }" />

  <div v-if="!$store.getters.editMode" :style="getStylePropertyTable">
    <PropertyTable :property="$store.getters.property" :second-property="$store.getters.propertyAll"
      :column-visible="propertyColumnVisible" tableName="PropertiesForm" />
  </div>

  <ScriptLogs v-if="!$store.getters.editMode" :style="getStyleLogs" />
  <!-- </div>-->
</template>

<style lang="scss" scoped>
/*.scada-form-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}*/
</style>
